const adminEndpoints = [
    "/api/v1/admin",
    "/api/internal",
    "/.spire/",
    "/admin/",
    "/userfiles/_system",
    "/.spire/generateBlueprintTranslations",
] as const;

const excludeFromAdminEndpoints = ["/.spire/shareEntity"] as const;

const getPathname = (endpoint: string) => {
    try {
        return new URL(endpoint, "http://localhost/").pathname.toLowerCase();
    } catch {
        return endpoint.split(/[?#]/, 1)[0]!.toLowerCase();
    }
};

const matchesPrefix = (pathname: string, prefix: string) => {
    const normalizedPrefix = prefix.toLowerCase();
    if (normalizedPrefix.endsWith("/")) {
        return pathname.startsWith(normalizedPrefix);
    }

    return pathname === normalizedPrefix || pathname.startsWith(`${normalizedPrefix}/`);
};

export const isAdminEndpoint = (endpoint: string) => {
    const pathname = getPathname(endpoint);
    return (
        adminEndpoints.some(a => matchesPrefix(pathname, a)) &&
        !excludeFromAdminEndpoints.some(a => matchesPrefix(pathname, a))
    );
};
